import React, {useEffect} from 'react';
import {Card, CardBody, CardTitle} from 'reactstrap';
import TableAdapter from '../../../components/TableAdapter/TableAdapter';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";


// components
import TypeServicesFilters from "./_filters";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

// labels
import {LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// service
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import {typeServicesService} from "../../../jwt/_services/clasificator/typeServicesService";
import TypeServicesForm from "./_form";


function TypeServicesList(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    // asignar los valores por default del filtro
    useEffect( () => {
        if(!app || !udn)
            return

        props.setFilter(path , {
            onlyRegistered : true,
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                udn : { id: udn.id }
            }
        } )
    }, [ app, udn ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, typeServicesService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path,  tableChangeParams.sizePerPage, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( TypeServicesForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);
        ModalFormContainer(TypeServicesForm, {path,  data, Form: TypeServicesForm })
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: typeServicesService
        } );
    };

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={typeServicesService} />
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'code',
            text: 'Código',
            headerStyle: {width: '100px'},
        }, {
            dataField: 'name',
            text: 'Nombre'
        },{
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align:'center',
            headerStyle: {width: '200px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <TypeServicesFilters path={path}/>
            <TableAdapter
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={{pageIndex, pageSize, totalSize}}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})
export default connect(mapStateToProps, mapActionsToProps)(TypeServicesList)
